import API from '../../../apis/kogan-api';

export const getProducts = () => {
  return API.get('products?size=200');
};

export const updateStockPrice = (stockPrice) => {
  return API.post('products/stockprice', stockPrice);
};

export const getProductBySku = (sku,detail) => {
  return API.get(`products?sku=${sku}&detail=${detail}`);
};

export const updateProducts = (products,force) => {
  force = force?force:false;
  return API.patch(`products?force=${force}`, products);
};

export const createProducts = (products) => {
  return API.post(`products`, products);
};

export const checkAsyncStatus = (taskId) => {
  return API.get(`tasks/${taskId}`);
}; 